import React, {Component} from 'react';
import cx from 'classnames';

export default class MakeContent extends Component {
    constructor(){
        super();
    }

    render(){
        const {innerHeight, displayStatic} = this.props;
        const makeContentTextClassnames = cx('make-content-text', {
            'make-content-text-web-static': displayStatic
        });
        let style;

        if(displayStatic){
            style = {
                height: '981px'
            }
        } else {
            style = {
                height: innerHeight
            }
        }

        return(
            <div className='gr-12 make-content' style={style}>
                <div className={makeContentTextClassnames}>
                    <h1>We're changing the way brands make content</h1>
                    <p>Drive powerful results with content that's fresh, authentic and already proven to engage. Create custom content from the lens of your consumers, for your consumers.</p>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/components/branded_content/make_content.js